import { h, render, Component } from 'preact';
import { Text} from 'preact-i18n';
import Markup from 'preact-markup';
import { GetSafeImageUrl } from '../utils/ApiUtil';
class RelatedVideoImages extends Component {
    constructor(props) {
        super(props);
        this.state = {
          seeMore: false
        }
    }
    componentDidMount() {
    }

    render() {
      let searchList = this.props.searches;
      let service = this.props.service;
      let affid = this.props.affid;
      let height = 40;
      let width = 40;
      let elemNumber = 8;
      if(!searchList.map || searchList.length == 0) {
        return (""); //defensive check
      }
      return (
        <div className="related-video-image-carousel">
          <div className='ae-caption'>
            {this.props.title}
          </div>
          <div className='related-videos-images'>
          {
            searchList.map((obj, i) => {
              let url = this.props.id !== "similar" ? obj.thumbnail.thumbnailUrl : obj.thumbnail.url
              if (i < elemNumber || i >= elemNumber && this.state.seeMore) {
                return(
                  <a className="ae-dark" href={`/search?q=${encodeURIComponent(obj.text)}&service=${service}&affid=${encodeURIComponent(affid)}`}>
                    <div className="ae-border-box related-video-image-card">
                      <div className="related-video-image-thumbnail">
                        <img src={GetSafeImageUrl(url + "&h=" + height + "&w=" + width)} height={height} width={width} />
                      </div>
                      <div className="ae-para related-video-image-text">
                        <Markup markup={obj.text} type="html" trim={false}/>
                      </div>
                    </div>
                  </a>
                )
              }
            })
          }
          { this.state.seeMore && searchList.length >= elemNumber ? 
            <a className='related-seemore' onClick={()=> {this.setState(c => {c.seeMore = !c.seeMore;return c;})}}><Text id="newSearch.seeLessSearches">See less...</Text></a> : ("")
          }
          { !this.state.seeMore && searchList.length >= elemNumber ?
            <a className='related-seemore' onClick={()=> {this.setState(c => {c.seeMore = !c.seeMore;return c;})}}><Text id="newSearch.seeMoreSearches">See more...</Text></a>  : ("")
          }
          </div>
        </div>
      )
    }
}
export default RelatedVideoImages;
